import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { AuthorService } from 'src/app/services/author.service';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { EditQuestionInQuestionSetModalPage } from '../edit-question-in-question-set-modal/edit-question-in-question-set-modal.page';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { SceneAssetRelation } from 'src/app/models/scene-asset-relations/SceneAssetRelation';

@Component({
  selector: 'app-add-questions-to-question-set-modal',
  templateUrl: './add-questions-to-question-set-modal.page.html',
  styleUrls: ['./add-questions-to-question-set-modal.page.scss'],
})
export class AddQuestionsToQuestionSetModalPage implements OnInit {

  public assetInScene: AssetInScene;
  public isModalOpen: boolean = false;

  constructor(
    public modalController: ModalController,
    public assetTypeService: AssetTypeService,
    public authorService: AuthorService,
    public unfocusService: UnfocusElementService,
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

  setModalTransparency(opacity: number) {
    document.getElementById('add-questions-to-question-set-modal').setAttribute('style', 'opacity: ' + opacity);
  }

  addQuestion(){
    this.authorService.addQuestionToAsset(this.assetInScene);
  }  

  async editQuestion(event, i: number){
    this.unfocusService.unfocus(event);

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    this.setModalTransparency(0);

    var questionSetAsset: QuestionSetAsset = this.assetInScene.baseAsset as QuestionSetAsset;
    questionSetAsset.questionIndex = i;

    const modal = await this.modalController.create({
      component: EditQuestionInQuestionSetModalPage,
      id: 'edit-question-in-question-set-modal',
      componentProps: {
        'assetInScene': this.assetInScene.assets[i]
      }
    });

    modal.onDidDismiss().then(result => {
      var questionSetAsset:QuestionSetAsset = this.assetInScene.baseAsset as QuestionSetAsset;
      questionSetAsset.questionIndex = questionSetAsset.coverPage == true ? -1 : 0;
      this.setModalTransparency(1);
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  removeQuestion(i: number){
    var assetsToBeRemoved = this.assetInScene.assets.splice(i, 1);
    assetsToBeRemoved[0].toBeRemoved = true;
    this.authorService.assetsInScene.push(assetsToBeRemoved[0]); // AFTER SAVE THE PROJECT THE QUESTION WILL BE DELETED
  }
}
